/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import defaultImg from '@/resources/images/mall/default_wanjia.jpg';
import ImgItem from '@/components/ImgItem';
export default {
  props: {
    item: {
      type: Object
    },
    direction: {
      type: String,
      "default": 'column'
    }
  },
  components: {
    ImgItem: ImgItem
  },
  computed: {
    imgComp: function imgComp() {
      return this.item.mainImageUrl || this.item.imageUrl;
    },
    width: function width() {
      if (this.direction == 'column') {
        return '3.48rem';
      } else {
        return '1.8rem';
      }
    }
  },
  data: function data() {
    return {
      defaultImg: defaultImg
    };
  },
  created: function created() {},
  methods: {
    goGoodsDetail: function goGoodsDetail() {
      var goodsId = this.item.goodsId;
      this.$router.push({
        name: 'MallGoodsDetail',
        query: {
          goodsId: goodsId
        }
      });
    }
  }
};